import { Typography } from '@mui/material';

export type ContentStackProps = {
  primary?: string;
  secondary?: string;
};

export const ContentStack: React.VFC<ContentStackProps> = ({ primary, secondary }) => {
  return (
    <div>
      {primary && <Typography variant="body2" color="textPrimary">{primary}</Typography>}
      {secondary && <Typography variant="body2">{secondary}</Typography>}
    </div>
  );
};
